import { useSelector } from "react-redux";
import { Helmet, HelmetProvider } from "react-helmet-async";
import posthog from "posthog-js";

import Navbar from "../components/navbar";
import Footer from "../components/Footer";

const POSTHOG_ENV = import.meta.env.VITE_POSTHOG_ID;

// Only initialize PostHog in production
if (import.meta.env.PROD) {
  posthog.init(POSTHOG_ENV, {
    api_host: "https://eu.i.posthog.com",
    person_profiles: "identified_only",
  });
}

const Layout = ({ children, title, description }) => {
  const token = useSelector((state) => state.token);
  const baseTitle = "Lokult - All musik från Strängnäs kommun på ett ställe";
  const metaTitle = title ? `${title} | Lokult` : baseTitle;
  const metaDescription = description
    ? description
    : "Upptäck musik och musiker ifrån Strängnäs Kommun.";

  return (
    <HelmetProvider>
      <Helmet>
        <html lang="sv" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://lokult.se" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta property="og:image:alt" content="A description of the image" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta
          property="og:image"
          content="https://lokult.se/assets/lokult_meta.wepb"
        />
      </Helmet>
      <div className="min-h-screen flex flex-col">
        <header className="z-40">
          <Navbar token={token} />
        </header>
        <main className="pt-4 flex-1">{children}</main>
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default Layout;
